"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: ", ";\n\tposition: fixed;\n\tz-index: 1;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: auto;\n\tbackground-color: rgb(0, 0, 0);\n\tbackground-color: rgba(0, 0, 0, 0.4);\n\tpadding-top: 60px;\n\tfont-family: \"Gotu\", sans-serif;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Modal = _styledComponents.default.div(_templateObject(), function (_ref) {
  var modal = _ref.modal;
  return modal ? "block" : "none";
});

var _default = Modal;
exports.default = _default;

//# sourceMappingURL=Modal.js.map